import { editor } from 'monaco-editor';

/**
 * React hook for creating a monacco editor validator
 * @param debounce the debounce time between edit and validation
 * @returns a function to call once the editor is mounted
 */
export const useLiveValidation = () => ({
  mountLiveValidator(editorInstance: editor.IStandaloneCodeEditor) {
    mountLiveValidator(editorInstance);
  },
});

/**
 * Mount a listener on the editor that continously validates the current editor model
 * @param editorInstance the monacco editor instance
 * @param client an ApolloClient for sending validation queries
 * @param debounce the debounce time between edit and validation
 */
const mountLiveValidator = (editorInstance: editor.IStandaloneCodeEditor) => {
  let removeCurrentHandler: (() => void) | null = null;
  const attachToModel = () => {
    if (removeCurrentHandler) {
      removeCurrentHandler();
      removeCurrentHandler = null;
    }
  };
  editorInstance.onDidChangeModel(attachToModel);
  attachToModel();
};
